import once from 'lodash/once';
import forEach from 'lodash/forEach';
import fbPixelIntegration from './facebook-pixel';
import gaEventIntegration, { ga4 as ga4Integration } from './ga-event';
import googleConversionTagIntegration from './gct';



const setupIntegrationRegister = (...registers) => (integration) => {
  registers.forEach((register) => register(integration));
};

const integrationRegisterMap = {
  'fbc_pixel': setupIntegrationRegister(fbPixelIntegration),
  'ga_tracker': setupIntegrationRegister(gaEventIntegration),
  'google_conversion_tag': setupIntegrationRegister(googleConversionTagIntegration),
  'google_analytics_4': setupIntegrationRegister(ga4Integration)
};

export default once((integrations) => {
  forEach(integrations, (integration) => {
    if (!integration.is_active) {
      return;
    }

    const integrationRegister = integrationRegisterMap[integration.type];
    const integrationRegisterNotExist = !integrationRegister;

    if (integrationRegisterNotExist) {
      return;
    }

    integrationRegister(integration);
  });
});



// WEBPACK FOOTER //
// ./src/lib/tracking-integrations/index.js